import {IDetailContrat} from '../../types/interface/Contrats/detailContrat';

export const defaultContratRCVP = {
  numeroPolice: '',
  typeContrat: '',
  typePayment: '',
  nomPrenomContractant: '',
  dateNaissanceContractant: '',
  dateEffet: '',
  telephoneContractant: '',
  telephoneContractantCountryCode: '',
  emailContractant: '',
  nombreAnimauxDomestique: '',
  adresse: '',
  agence: '',
  primeTTC: '',
  is_recurrent: false,
  operationType: '',
  simulationId: '',
  utilisateur: '',
};

export const defaultContratScolaire = {
  numeroPolice: '',
  typeContrat: '',
  typePayment: '',
  nomPrenomContractant: '',
  telephoneContractant: '',
  telephoneContractantCountryCode: '',
  emailContractant: '',
  dateNaissanceContractant: '',
  adresse: '',
  agence: '',
  primeTTC: '',
  nomPrenomEleveAssure: '',
  dateNaissanceEleveAssure: '',
  etablissementScolaire: '',
  anneeScolaire: '',
  is_recurrent: false,
  dateEffet: '',
  operationType: '',
  simulationId: '',
  utilisateur: '',
};

export const detailContratDTO: IDetailContrat = {
  nomPrenomContractant: '',
  emailContractant: '',
  nombreAnimauxDomestique: -1,
  adresse: '',
  agence: '',
  primeTTC: '',
  id: '',
  version: '',
  dateNaissanceContractant: '',
  nomPrenomAssure: '',
  dateNaissanceAssure: '',
  telephoneAssure: '',
  telephoneAssureCountryCode: '',
  adresseAssure: '',
  emailAssure: '',
  nomPrenomEleveAssure: '',
  dateNaissanceEleveAssure: '',
  etablissementScolaire: '',
  anneeScolaire: '',
  premierVersement: '',
  beneficiaireCasDeces: '',
  telephoneContractant: '',
  numeroPolice: '',
  dateEffet: '',
  dateEcheance: '',
  typePayment: '',
  typeContratPayment: '',
  is_recurrent: false,
  is_ending: false,
  isAvenant: false,
  // TODO: review the fieldNames for garanties
  garanties: [],
  carMarque: '',
  carType: '',
  immatriculation: '',
  placeAssure: 0,
  codeImpression: '',
  statusImpression: '',
  utilisateurId: false,
  dateSouscription: '',
  type: '',
  numEleveAssure: 0,
  sourscripteurId: 0,
  beneficiaries: [],
  policyNumber: false,
  dateDebut: false,
  dateFin: false,
  destination: false,
  status: '',
};

export const defaultVersion = {
  dateEcheance: '',
  dateSouscription: '',
  numeroPolice: '',
  objetRisque: '',
  prime: 0,
  smp: 0,
};

export const ETAT_IMPRESSION = {
  IMPRIME: 1,
  NON_IMPRIME: 0,
};
